export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#2B0028',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FF5FF8',
  },
  {
    path: 'M326.4 325.632h64V691.2h-64zM639.232 515.072c-4.608-32.256-28.16-49.664-60.416-49.664-30.208 0-72.704 15.872-72.704 96.256 0 44.032 19.456 90.624 70.144 90.624 33.792 0 57.344-22.528 62.976-60.416H697.6c-10.752 68.608-53.248 106.496-121.344 106.496-82.944 0-128.512-58.88-128.512-136.704 0-79.872 43.52-142.336 130.56-142.336 61.44 0 113.664 30.72 119.296 95.744z',
    fill: '#FF5FF8',
  },
]
